import { createReducer } from '@reduxjs/toolkit';

import postEasyPostBuyShipment from '../../../thunks/shipment/easyPost/postEasyPostBuyShipment';
import postEasyPostShipmentClearState from '../../../actions/shipment/easyPost/postEasyPostBuyShipment';

const initialState = {
  loading: false,
  error: null,
  data: undefined,
};

const postEasyPostBuyShipmentReducer = createReducer(initialState, {
  [postEasyPostBuyShipment.pending]: (state) => ({
    ...state,
    loading: true,
    error: null,
  }),
  [postEasyPostBuyShipment.fulfilled]: (state, { payload }) => ({
    ...state,
    loading: false,
    data: payload
  }),
  [postEasyPostBuyShipment.rejected]: (state, { payload }) => ({
    ...state,
    loading: false,
    error: payload,
    data: undefined
  }),
  [postEasyPostShipmentClearState]: () => initialState,

});

export default postEasyPostBuyShipmentReducer;
